import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { usePunditUserContext } from "@circle-react/contexts";
import { TabContainer } from "../../components/TabContainer";
import { TabContainerGroup } from "../../components/TabContainerGroup";
import { TabHeader } from "../../components/TabHeader";
import { CustomRedirectInputText } from "./Fields/CustomRedirectInputText";
import { CustomRedirectToggle } from "./Fields/CustomRedirectToggle";
import { EnablePostPurchaseToggle } from "./Fields/EnablePostPurchaseToggle";
import { PostPurchaseBodyTextArea } from "./Fields/PostPurchaseBodyTextArea";
import { PostPurchaseCustomButtonLabelInputText } from "./Fields/PostPurchaseCustomButtonLabelInputText";
import { PostPurchaseCustomButtonUrlInputText } from "./Fields/PostPurchaseCustomButtonUrlInputText";
import { PostPurchaseEmailToggle } from "./Fields/PostPurchaseEmailToggle";
import { PostPurchaseSubjectInputText } from "./Fields/PostPurchaseSubjectInputText";
import { WorkflowsBanner } from "./WorkflowsBanner";
import "./style.scss";

interface PostPurchaseTabProps {
  setActiveTab: (tab: string) => void;
  shouldDisplayWorkflowsTab: boolean;
}

export const PostPurchaseTab = ({
  shouldDisplayWorkflowsTab,
  setActiveTab,
}: PostPurchaseTabProps) => {
  const { currentCommunitySettings } = usePunditUserContext();
  const { watch, setValue } = useFormContext();

  const [isPostPurchaseEmailEnabled, isRedirectUrlEnabled] = watch([
    "post_purchase_email_enabled",
    "redirect_url_enabled",
  ]);

  const shouldDisplayWorkflowsBanner =
    shouldDisplayWorkflowsTab &&
    currentCommunitySettings?.upgrade_flows_for_workflows_paywalls_enabled;

  useEffect(() => {
    if (!isRedirectUrlEnabled) {
      setValue("redirect_url", "");
    }
  }, [isRedirectUrlEnabled]);

  return (
    <TabContainer>
      <TabHeader
        title={t("settings.paywalls.modal.tabs.post_purchase.title")}
      />
      <TabContainerGroup>
        <WorkflowsBanner
          setActiveTab={setActiveTab}
          hide={!shouldDisplayWorkflowsBanner}
        />
        <EnablePostPurchaseToggle />
        <TabContainerGroup className="gap-y-2">
          <CustomRedirectToggle />
          <CustomRedirectInputText isDisabled={!isRedirectUrlEnabled} />
        </TabContainerGroup>
        <PostPurchaseEmailToggle />
      </TabContainerGroup>
      <TabContainerGroup
        className={classNames({
          "opacity-50": !isPostPurchaseEmailEnabled,
        })}
      >
        <PostPurchaseSubjectInputText
          isDisabled={!isPostPurchaseEmailEnabled}
        />
        <PostPurchaseBodyTextArea isDisabled={!isPostPurchaseEmailEnabled} />
        <PostPurchaseCustomButtonLabelInputText
          isDisabled={!isPostPurchaseEmailEnabled}
        />
        <PostPurchaseCustomButtonUrlInputText
          isDisabled={!isPostPurchaseEmailEnabled}
        />
      </TabContainerGroup>
    </TabContainer>
  );
};
